import { Redacted } from "effect";
import { privateDependencyFailure } from "./private-cause.ts";

export const ChangeReviewError = /* @__PURE__ */ (() => {
  class ChangeReviewError extends privateDependencyFailure<ChangeReviewError>()("ChangeReviewError", "change review") {}
  return ChangeReviewError;
})();
export type ChangeReviewError = InstanceType<typeof ChangeReviewError>;
export const changeReviewError = (cause: unknown) => new ChangeReviewError({ cause: Redacted.make(cause) });
